module.exports = __webpack_public_path__ + "static/media/clickup.729cb1ee.svg";